import { useTranslation } from "react-i18next";
import { Fragment } from "react";
import { getDisplayDatetime } from "../../helpers/display_help";
import { Button } from "reactstrap";

function AdminDeviceContractRow(props) {
    const { t } = useTranslation();
    const data = props.data;

    return (
        <Fragment>
            <tr>
                <td style={{ width: 100 }}>{data["id"]}</td>
                <td style={{ width: 40 }} className="fw-medium">{data["admin_device_id"]}</td>
                <td style={{ width: 40 }} className="fw-medium">{data["device"] === null? "" :data["device"]["monitor_location_device_id"]}</td>
                <td style={{ width: 200 }}>{data["device"] === null? "" :data["device"]["admin_company"]["name"]}</td>
                <td style={{ width: 100 }}>{data["start_date"]}</td>
                <td style={{ width: 100 }}>{data["end_date"]}</td>
                <td style={{ width: 200 }}>{getDisplayDatetime(data["created_at_epoch"] * 1000)}</td>
                <td style={{ width: 100 }}>{data["updatedByUser"]["username"]}</td>
                <td>
                    <textarea
                        value={data["remark"] || ""}
                        readOnly
                        style={{
                            width: '100%',
                            minHeight: '2.25rem',
                            resize: 'vertical',
                            border: 'none',
                            background: 'transparent',
                            fontSize: 'inherit',
                            fontFamily: 'inherit',
                            padding: 0,
                            outline: 'none',
                            overflow: 'auto'
                        }}
                    />
                </td>
                <td style={{padding: "0.51rem 0.6rem"}}>
                    <Button className="btn-sm btn-primary" onClick={(e) => { e.stopPropagation(); props.onClickModify();}}>{t('Common.Btn.Modify')}</Button>
                </td>
            </tr>
        </Fragment>
    );
}

export default AdminDeviceContractRow;
